/* eslint-disable react-hooks/rules-of-hooks */
import { Locale, Markets } from 'generated/graphql';
import { getLocale } from 'modules/localesMapper';
import { GetServerSideProps } from 'next';
import { getStory } from '../../lib/graphql/getStory';
import PageComponentMapper from '../../modules/componentMapping/pageComponentMapper';
import React from 'react';
import { ContainerButtons } from '../../components/Press/DownloadArea/styles';
import { getCopy } from '../../lib/utils/getCopy';
import { Text, Title } from '../../components/Typography';
import {
  Background,
  HeaderContainer,
  HeaderContainerFlex,
  HeaderInnerContainer,
  HeaderTextArea,
  ImageArea,
  MaskBottom,
} from '../../components/Press/Header/styles';
import { CurveMask } from '../../components/CurveMask';
import { ShareButton } from '../../components/ShareButton';
import { ContainerSubline } from '../../components/Press/ListingPage/style';
import { PageMetaData } from '../../components/metaData';
import Custom404 from '../404';
import { ISocialMediaListComponents } from '../../types/SocialSharing';
import { INotificationBannerProps } from '../../components/NotificationBanner/types';

function StoriesPage({
  serverData,
  locale,
  serverError,
  dictionary,
}: {
  serverData: any;
  env: string;
  locale: Locale;
  market: Markets;
  recallData: INotificationBannerProps;
  serverError: boolean;
  dictionary: any;
}) {
  if (serverError) {
    return <Custom404 dictionary={dictionary} />;
  }

  const story = serverData.stories[0];

  if (story === undefined) {
    return <Custom404 dictionary={dictionary} />;
  }

  const publishedAt = new Date(story.date);
  const socialMediaList: ISocialMediaListComponents[] = [
    {
      name: 'Twitter',
      shareMsg: 'Tweet it',
      socialMediaComponentName: 'TwitterShareButton',
      socialSharePosition: ['SocialShareComponent'],
      assetsComponents: [
        {
          asset: [
            {
              url: 'https://media.graphassets.com/PzcyJyNOTu2aoan13zXX',
            },
          ],
        },
      ],
    },
    {
      name: 'facebook',
      shareMsg: 'Share it',
      socialMediaComponentName: 'FacebookShareButton',
      socialSharePosition: ['SocialShareComponent'],
      assetsComponents: [
        {
          asset: [
            {
              url: 'https://media.graphassets.com/gmH97uIpT5gtgiLR0JAJ',
            },
          ],
        },
      ],
    },
    {
      name: 'whatsapp',
      shareMsg: 'Send it',
      socialMediaComponentName: 'WhatsappShareButton',
      socialSharePosition: ['SocialShareComponent'],
      assetsComponents: [
        {
          asset: [
            {
              url: 'https://media.graphassets.com/vD6OwF3XQn6hw6p67sGu',
            },
          ],
        },
      ],
    },
    {
      name: 'linkedin',
      shareMsg: 'Share it',
      socialMediaComponentName: 'LinkedinShareButton',
      socialSharePosition: ['SocialShareComponent'],
      assetsComponents: [
        {
          asset: [
            {
              url: 'https://media.graphassets.com/5zS3hXXkR5SEoT4zXlLh',
            },
          ],
        },
      ],
    },
  ];
  const storiesMeta = serverData?.stories[0]?.metaData;
  return (
    <>
      {storiesMeta && <PageMetaData metadata={storiesMeta} locale={locale} />}
      <HeaderContainer>
        <Background className="curve-mask-top" $customColor={'rgb(1, 14, 84)'}>
          <MaskBottom className="curve-mask-bottom">
            <HeaderInnerContainer className={'type-story'}>
              <HeaderContainerFlex>
                <HeaderTextArea>
                  <Text type="lead" tag="p">
                    {getCopy('dr._oetker_stories', dictionary)}
                  </Text>
                  <Title tag="h1" type="lg" className="py-4">
                    {story.title}
                  </Title>
                  <Text type="lg" tag="p">
                    {story.teaser}
                  </Text>
                </HeaderTextArea>
                <ImageArea>
                  {story.image?.url && (
                    <img src={story.image.url ?? ''} alt={story.title} width="100%" />
                  )}
                </ImageArea>
              </HeaderContainerFlex>
            </HeaderInnerContainer>
            <CurveMask />
          </MaskBottom>
        </Background>
      </HeaderContainer>
      <ContainerSubline>
        <Title type={'lead'} tag="p">
          {`${publishedAt.getDate()}.${publishedAt.getMonth() + 1}.${publishedAt.getFullYear()}`} •{' '}
          {getCopy(`story_tag_${story.storyTagEnum}`, dictionary)}
        </Title>
      </ContainerSubline>
      <ContainerButtons>
        {/* <a href="javascript:window.print()">
          <CorporateButton
            color="tertiary"
            type="lead"
            icon={<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.9375 11.9688C16.5547 11.9688 16.2812 12.2695 16.2812 12.625C16.2812 13.0078 16.5547 13.2812 16.9375 13.2812C17.293 13.2812 17.5938 13.0078 17.5938 12.625C17.5938 12.2695 17.293 11.9688 16.9375 11.9688ZM17.8125 9.5625V7.48438C17.8125 7.15625 17.6484 6.80078 17.4023 6.55469L16.0078 5.16016C15.7617 4.91406 15.4062 4.75 15.0781 4.75H9.00781C8.54297 4.75 8.1875 5.16016 8.1875 5.625V9.5625C6.95703 9.5625 6 10.5469 6 11.75V15.25C6 15.4961 6.19141 15.6875 6.4375 15.6875H8.1875V18.3125C8.1875 18.5586 8.37891 18.75 8.625 18.75H17.375C17.5938 18.75 17.8125 18.5586 17.8125 18.3125V15.6875H19.5625C19.7812 15.6875 20 15.4961 20 15.25V11.75C20 10.5469 19.0156 9.5625 17.8125 9.5625ZM9.5 6.0625H14.75V7.375C14.75 7.62109 14.9414 7.8125 15.1875 7.8125H16.5V9.5625H9.5V6.0625ZM16.5 17.4375H9.5V15.6875H16.5V17.4375ZM18.6875 14.375H7.3125V11.75C7.3125 11.2852 7.69531 10.875 8.1875 10.875H17.8125C18.2773 10.875 18.6875 11.2852 18.6875 11.75V14.375Z" fill="#292B29" />
            </svg>}
            label={getCopy('print', dictionary)} />
        </a> */}
        <ShareButton
          isGeneric={true}
          socialMediaListComponents={socialMediaList}
          labels={{
            share: getCopy('share', dictionary),
          }}
        />
      </ContainerButtons>

      <PageComponentMapper components={story?.pageComponents} copy={dictionary || []} />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { locale = 'global', locales, resolvedUrl, params } = ctx;

  const error = false;
  const market = locale; // locale from path is representing market
  const currLocale = getLocale(market);
  const pageData = await getStory(market, currLocale, params?.slug?.toString() || '');
  const data = pageData?.data;

  return {
    props: {
      locale: currLocale,
      env: process.env.RECIPE_ENV?.toLowerCase() || 'dev',
      serverData: data || {},
      locales,
      market,
      serverError: error,
    },
  };
};
export default StoriesPage;
